(ns io.daskul.webapp.ui.icons
  "Tabler icons for UIx.

   Uses individual icon imports instead of the barrel export to avoid
   bundling all 5000+ icons (~2.5 MB). Each icon is ~1 KB individually."
  (:require
   ;; Navigation
   ["@tabler/icons-react/dist/esm/icons/IconBuilding" :default IconBuilding]
   ["@tabler/icons-react/dist/esm/icons/IconUsers" :default IconUsers]
   ["@tabler/icons-react/dist/esm/icons/IconUserCircle" :default IconUserCircle]
   ["@tabler/icons-react/dist/esm/icons/IconLogout" :default IconLogout]
   ["@tabler/icons-react/dist/esm/icons/IconArrowLeft" :default IconArrowLeft]
   ;; Actions
   ["@tabler/icons-react/dist/esm/icons/IconTrash" :default IconTrash]
   ["@tabler/icons-react/dist/esm/icons/IconPlus" :default IconPlus]
   ["@tabler/icons-react/dist/esm/icons/IconEdit" :default IconEdit]
   ["@tabler/icons-react/dist/esm/icons/IconChevronDown" :default IconChevronDown]
   ["@tabler/icons-react/dist/esm/icons/IconChevronRight" :default IconChevronRight]
   ["@tabler/icons-react/dist/esm/icons/IconChevronLeft" :default IconChevronLeft]
   ;; FSM states
   ["@tabler/icons-react/dist/esm/icons/IconCheck" :default IconCheck]
   ["@tabler/icons-react/dist/esm/icons/IconPencil" :default IconPencil]
   ["@tabler/icons-react/dist/esm/icons/IconArchive" :default IconArchive]
   ["@tabler/icons-react/dist/esm/icons/IconGlobe" :default IconGlobe]
   ["@tabler/icons-react/dist/esm/icons/IconCalendar" :default IconCalendar]
   ["@tabler/icons-react/dist/esm/icons/IconClock" :default IconClock]
   ["@tabler/icons-react/dist/esm/icons/IconX" :default IconX]
   ["@tabler/icons-react/dist/esm/icons/IconAlertCircle" :default IconAlertCircle]
   ["@tabler/icons-react/dist/esm/icons/IconAlertTriangle" :default IconAlertTriangle]
   ["@tabler/icons-react/dist/esm/icons/IconInfoCircle" :default IconInfoCircle]
   ["@tabler/icons-react/dist/esm/icons/IconCircleCheck" :default IconCircleCheck]
   ["@tabler/icons-react/dist/esm/icons/IconPlayerPlay" :default IconPlayerPlay]
   ["@tabler/icons-react/dist/esm/icons/IconSend" :default IconSend]
   ["@tabler/icons-react/dist/esm/icons/IconCircleX" :default IconCircleX]
   ;; Sort
   ["@tabler/icons-react/dist/esm/icons/IconArrowsSort" :default IconArrowsSort]
   ;; Search/filter
   ["@tabler/icons-react/dist/esm/icons/IconSearch" :default IconSearch]
   ["@tabler/icons-react/dist/esm/icons/IconFilter" :default IconFilter]
   ["@tabler/icons-react/dist/esm/icons/IconFilterOff" :default IconFilterOff]
   ;; Billing
   ["@tabler/icons-react/dist/esm/icons/IconDiscount" :default IconDiscount]
   ;; Organization
   ["@tabler/icons-react/dist/esm/icons/IconBuildingCommunity" :default IconBuildingCommunity]
   ;; Sections
   ["@tabler/icons-react/dist/esm/icons/IconLayoutGrid" :default IconLayoutGrid]
   ;; Entity icons
   ["@tabler/icons-react/dist/esm/icons/IconUser" :default IconUser]
   ["@tabler/icons-react/dist/esm/icons/IconClipboardList" :default IconClipboardList]
   ["@tabler/icons-react/dist/esm/icons/IconFolder" :default IconFolder]
   ["@tabler/icons-react/dist/esm/icons/IconPackage" :default IconPackage]
   ["@tabler/icons-react/dist/esm/icons/IconTag" :default IconTag]
   ["@tabler/icons-react/dist/esm/icons/IconList" :default IconList]
   ["@tabler/icons-react/dist/esm/icons/IconAddressBook" :default IconAddressBook]
   ;; Navigation (detail links)
   ["@tabler/icons-react/dist/esm/icons/IconExternalLink" :default IconExternalLink]
   ;; Security
   ["@tabler/icons-react/dist/esm/icons/IconLock" :default IconLock]
   ["@tabler/icons-react/dist/esm/icons/IconChevronUp" :default IconChevronUp]
   ;; Overflow
   ["@tabler/icons-react/dist/esm/icons/IconDots" :default IconDots]
   ;; Status indicator dot (#858 :indicator renderer)
   ["@tabler/icons-react/dist/esm/icons/IconPointFilled" :default IconPointFilled]
   ;; Dashboard
   ["@tabler/icons-react/dist/esm/icons/IconLayoutDashboard" :default IconLayoutDashboard]
   ["@tabler/icons-react/dist/esm/icons/IconRefresh" :default IconRefresh]
   ["@tabler/icons-react/dist/esm/icons/IconReceipt" :default IconReceipt]
   ["@tabler/icons-react/dist/esm/icons/IconSchool" :default IconSchool]
   ["@tabler/icons-react/dist/esm/icons/IconCash" :default IconCash]
   ;; Trends
   ["@tabler/icons-react/dist/esm/icons/IconChartBar" :default IconChartBar]
   ["@tabler/icons-react/dist/esm/icons/IconTrendingUp" :default IconTrendingUp]
   ["@tabler/icons-react/dist/esm/icons/IconTrendingDown" :default IconTrendingDown]
   ["@tabler/icons-react/dist/esm/icons/IconMinus" :default IconMinus]
   ;; People
   ["@tabler/icons-react/dist/esm/icons/IconHeartHandshake" :default IconHeartHandshake]
   ;; Academics
   ["@tabler/icons-react/dist/esm/icons/IconBook" :default IconBook]
   ;; Enrollment
   ["@tabler/icons-react/dist/esm/icons/IconUserCheck" :default IconUserCheck]
   ;; Requirements
   ["@tabler/icons-react/dist/esm/icons/IconChecklist" :default IconChecklist]
   ["@tabler/icons-react/dist/esm/icons/IconTemplate" :default IconTemplate]
   ;; Messaging
   ["@tabler/icons-react/dist/esm/icons/IconMessageCircle" :default IconMessageCircle]
   ;; Files
   ["@tabler/icons-react/dist/esm/icons/IconUpload" :default IconUpload]
   ["@tabler/icons-react/dist/esm/icons/IconFile" :default IconFile]
   ;; Attachments (SMS-182)
   ["@tabler/icons-react/dist/esm/icons/IconMicrophone" :default IconMicrophone]
   ["@tabler/icons-react/dist/esm/icons/IconVideo" :default IconVideo]
   ["@tabler/icons-react/dist/esm/icons/IconPaperclip" :default IconPaperclip]
   ["@tabler/icons-react/dist/esm/icons/IconLink" :default IconLink]
   ["@tabler/icons-react/dist/esm/icons/IconUnlink" :default IconUnlink]))

;; Navigation
(def icon-building IconBuilding)
(def icon-users IconUsers)
(def icon-user-circle IconUserCircle)
(def icon-logout IconLogout)
(def icon-arrow-left IconArrowLeft)

;; Actions
(def icon-trash IconTrash)
(def icon-plus IconPlus)
(def icon-edit IconEdit)
(def icon-chevron-down IconChevronDown)
(def icon-chevron-right IconChevronRight)
(def icon-chevron-left IconChevronLeft)

;; FSM states
(def icon-check IconCheck)
(def icon-pencil IconPencil)
(def icon-archive IconArchive)
(def icon-globe IconGlobe)
(def icon-calendar IconCalendar)
(def icon-clock IconClock)
(def icon-x IconX)
(def icon-alert-circle IconAlertCircle)
(def icon-alert-triangle IconAlertTriangle)
(def icon-info-circle IconInfoCircle)
(def icon-circle-check IconCircleCheck)
(def icon-player-play IconPlayerPlay)
(def icon-send IconSend)
(def icon-circle-x IconCircleX)

;; Sort
(def icon-arrows-sort IconArrowsSort)

;; Search/filter
(def icon-search IconSearch)
(def icon-filter IconFilter)
(def icon-filter-off IconFilterOff)

;; Organization
(def icon-building-community IconBuildingCommunity)

;; Sections
(def icon-layout-grid IconLayoutGrid)

;; Entity icons
(def icon-user IconUser)
(def icon-clipboard-list IconClipboardList)
(def icon-folder IconFolder)
(def icon-package IconPackage)
(def icon-tag IconTag)
(def icon-list IconList)
(def icon-address-book IconAddressBook)

;; Billing
(def icon-discount IconDiscount)

;; Navigation (detail links)
(def icon-external-link IconExternalLink)

;; Security
(def icon-lock IconLock)
(def icon-chevron-up IconChevronUp)

;; Overflow
(def icon-dots IconDots)
(def icon-point-filled IconPointFilled)

;; Dashboard
(def icon-dashboard IconLayoutDashboard)
(def icon-refresh IconRefresh)
(def icon-receipt IconReceipt)
(def icon-school IconSchool)
(def icon-cash IconCash)

;; Trends
(def icon-chart-bar IconChartBar)
(def icon-trending-up IconTrendingUp)
(def icon-trending-down IconTrendingDown)
(def icon-minus IconMinus)

;; People
(def icon-heart-handshake IconHeartHandshake)

;; Academics
(def icon-book IconBook)

;; Enrollment
(def icon-user-check IconUserCheck)

;; Requirements
(def icon-checklist IconChecklist)
(def icon-template IconTemplate)

;; Messaging
(def icon-message-circle IconMessageCircle)

;; Files
(def icon-upload IconUpload)
(def icon-file IconFile)

;; Attachments (SMS-182)
(def icon-microphone IconMicrophone)
(def icon-video IconVideo)
(def icon-paperclip IconPaperclip)
(def icon-link IconLink)
(def icon-unlink IconUnlink)
